import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import useData from "./data";

export default function DeleteExpenseGroup() {
  const { group_id } = useParams();
  const { isAdmin, loading, deleteExpenseGroup } = useData(group_id);

  if (loading) {
    return <Spinner color="primary" />;
  }

  return (
    <div className="p-3 text-center mt-3">
      {isAdmin ? (
        <>
          <h4>Delete Expense Group</h4>
          <p>Are you sure you want to delete this expense group?</p>
          <button
            className="btn btn-danger"
            onClick={() => {
              deleteExpenseGroup();
            }}
          >
            Delete
          </button>
        </>
      ) : (
        <div className="alert alert-danger">
          You are not authorized to delete this expense group
        </div>
      )}
    </div>
  );
}
